import { generator, compose } from './theme.js';

const overflow = (props) => generator({
    props,
    prop: ['overflow'],
    cssProperty: 'overflow',
});
const overflowX = (props) => generator({
    props,
    prop: ['overflowX'],
    cssProperty: 'overflow-x',
});
const overflowY = (props) => generator({
    props,
    prop: ['overflowY'],
    cssProperty: 'overflow-y',
});
const overflows = compose(overflow, overflowX, overflowY);

export { overflow, overflowX, overflowY, overflows };
